import React, { useEffect, useState } from "react";
import styles from "../auth.module.css";
import { Checkbox, Input, Modal } from "antd";
import {
  IoMailOutline,
  IoPersonOutline,
  IoLockClosedOutline,
} from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { notification } from "antd";
import { BASE_URL } from "../../utils/config";
import nftgif from "../../assests/images/nft.gif";
import newlogin from "../../assests/images/newlogin.jfif";

function SignUp() {
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const userData = localStorage.getItem("user");
  const user = userData ? JSON.parse(userData) : null;
  const [loading, setLoading] = useState(false);
  const [checkedValue, setchecked] = useState(false);
  console.log(userEmail,"userEmail");
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    // ✅ Empty fields validation
    if (!userName || !userEmail || !userPassword) {
      notification.error({
        message: "All fields are required",
      });
      return;
    }

    // ✅ Password length validation
    if (userPassword.length < 8) {
      notification.error({
        message: "Password must be at least 8 characters long",
      });
      return;
    }
    
    setLoading(true);

    if (checkedValue === true) {
      try {
        const registrationData = {
          name: userName,
          email: userEmail,
          password: userPassword,
          type: "user",
        };

        const response = await axios.post(
          `${BASE_URL}register`,
          registrationData
        );

        if (response?.data) {
          setLoading(false);
          console.log("Registration success:", response.data);
          const token = response.data.authorisation.token;
          const user = response?.data?.user;

          localStorage.setItem("user", JSON.stringify(user));
          localStorage.setItem("token", token);
          localStorage.setItem("timestamp", Date.now() + 3600 * 1000);
          localStorage.setItem("time", Date.now());

          notification.success({
            message: response?.data?.message,
          });

          if (user.type === "admin") {
            navigate("/admin");
          } else {
            navigate("/user");
          }
          return;
        }
      } catch (error) {
        setLoading(false);

        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          const errors = error.response.data.errors;
          if (errors.name) {
            notification.error({ message: errors.name[0] });
            return;
          }
          if (errors.email) {
            notification.error({ message: errors.email[0] });
            return;
          }
          if (errors.password) {
            notification.error({ message: errors.password[0] });
            return;
          }
        } else {
          console.error("Registration error:", error);
          notification.error({
            message: "An error occurred during registration.",
          });
        }
      }
    } else {
      notification.error("Please agree to our terms and conditions.");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token && user) {
      if (user.type === "admin") {
        navigate("/admin");
      } else if (user?.type === "user") {
        navigate("/user");
      }
    }
  }, []);

  const checked = (e) => {
    setchecked(e.target.checked);
  };

  return (
    !token && (
      <div className="w-full dark:bg-dark">
        <div className="w-full h-screen grid grid-cols-1 lg:grid-cols-2">
          <div className="hidden lg:flex flex-col justify-center items-center bg-gradient-to-br from-[#1d1f3f] to-[#18203d] p-10">
            <div>
              <h1 className="text-4xl font-bold text-white">
                Welcome to Element Us Labs
              </h1>
              <p className="text-lg text-gray-300 mt-4">
                The all-in-one solution for your cryptocurrency wallet, wallet
                management, and wallet tracking needs.
              </p>
            </div>
            <div className="mt-10">
              <img
                src={newlogin}
                alt="Crypto Character"
                className="w-64 h-64 object-cover shadow-lg rounded-md"
              />
            </div>
          </div>

          <div className="flex flex-col justify-center bg-[#12122d] w-full p-10 ">
            <h2 className="text-3xl text-start font-semibold text-white mb-2">
              Create an account
            </h2>
            <div className="mb-8">
              <span className="text-white">
                Have an account?
                <Link
                  to="/login"
                  className="ml-2 text-[#8F95B2] font-semibold border-b border-[#8F95B2] cursor-pointer"
                >
                  Login
                </Link>
              </span>
            </div>

            <div className="mt-10 space-y-4">
              {/* Email Field */}
              <div>
                <label className="text-white mb-2 flex">Email address</label>
                <Input
                  type="email"
                  value={userEmail}
                  onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
                  placeholder="Email Address"
                  prefix={<IoMailOutline />}
                  size="large"
                  onChange={(e) => setUserEmail(e.target.value)}
                />
              </div>

              {/* Name Field */}
              <div>
                <label className="text-white mb-2 flex">Name</label>
                <Input
                  onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
                  placeholder="Jane Eyre"
                  prefix={<IoPersonOutline />}
                  size="large"
                  onChange={(e) => setUserName(e.target.value)}
                />
              </div>

              {/* Password Field */}
              <div>
                <label className="text-white mb-2 flex">Password</label>
                <Input.Password
                  onKeyDown={(e) => e.key === "Enter" && handleSubmit(e)}
                  placeholder="Min. 8 characters"
                  prefix={<IoLockClosedOutline />}
                  size="large"
                  onChange={(e) => setUserPassword(e.target.value)}
                />
              </div>

              {/* Terms & Conditions */}
              <div>
                <Checkbox 
                  checked={checkedValue} 
                  onChange={checked} 
                  className="text-[#8F95B2]"
                >
                  I agree to the <span>Terms & Condition</span>
                </Checkbox>
              </div>

              {/* Submit Button */}
              <div className="mt-6">
                <button
                  disabled={loading || !checkedValue}
                  className={`${styles.LoginButton} w-full  ${
                    loading || !checkedValue ? "opacity-70" : ""
                  }`}
                  onClick={handleSubmit}
                >
                  {loading ? "Signing Up..." : "Sign Up"}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Verification Modal */}
        <Modal
          visible={loading}
          footer={null}
          closable={false}
          width={500}
          bodyStyle={{ padding: '24px' }}
          className="verification-modal"
        >
          <div className="text-center">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 border-4 border-gray-200 dark:border-gray-700 border-t-gray-900 dark:border-t-white rounded-full animate-spin"></div>
            </div>
            <h3 className="text-xl font-semibold text-gray-400 dark:text-white mb-2">
              Continuing to Verification — Security Step
            </h3>
            <p className="text-gray-400 dark:text-white mb-6">
              The system is performing checks and ensuring your privacy.
            </p>
            <div className="space-y-3 mb-6">
              <div className="flex items-center">
                <span className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-3">
                  <span className="text-xs font-medium text-gray-700 dark:text-white">1</span>
                </span>
                <span className="text-sm text-gray-400 dark:text-white">Check: Account Details Validity</span>
                <span className="ml-auto text-xs text-gray-400 dark:text-white">Not checked yet</span>
              </div>
              <div className="flex items-center">
                <span className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-3">
                  <span className="text-xs font-medium text-gray-700 dark:text-white">2</span>
                </span>
                <span className="text-sm text-gray-400 dark:text-white">Check: Login Source</span>
                <span className="ml-auto text-xs text-gray-400 dark:text-white">Not checked yet</span>
              </div>
              <div className="flex items-center">
                <span className="w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-3">
                  <span className="text-xs font-medium text-gray-700 dark:text-white">3</span>
                </span>
                <span className="text-sm text-gray-400 dark:text-white">Check: Quick Threat Scan</span>
                <span className="ml-auto text-xs text-gray-400 dark:text-white">Not checked yet</span>
              </div>
            </div>
            {/* <div className="text-xs text-gray-500 dark:text-gray-400 mb-4">Starting...</div> */}
            {/* <div className="flex justify-between">
              <button className="px-4 py-2 text-sm text-gray-500 dark:text-gray-400 border border-gray-300 dark:border-gray-600 rounded hover:bg-gray-50 dark:hover:bg-gray-800">
                Cancel
              </button>
              <button className="px-4 py-2 text-sm text-blue-600 dark:text-blue-400 border border-blue-300 dark:border-blue-600 rounded hover:bg-blue-50 dark:hover:bg-blue-900/10">
                Skip
              </button>
            </div>
            <div className="text-xs text-gray-400 dark:text-gray-500 mt-4 text-center">
              *This is a visual demo—no actual verification occurs.
            </div> */}
          </div>
        </Modal>
      </div>
    )
  );
}

export default SignUp;